import clsx from "clsx";

const SocialLinks = ({ links }) => {
  return (
    <div className={clsx("SocialLinks", "flex")}>
      {links.map((link) => {
        if (!link.url) return;

        return (
          <a
            key={link.label}
            href={link.url}
            target="_blank"
            className={clsx(
              "text-xs px-2 py-1 rounded-sm text-white-01",
              "inline-block",
              "mr-4 last-of-type:mr-0",
              "bg-blue-01"
            )}
          >
            {link.label}
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
